<template>
  <mdb-container class="gp-has-header text-left">
    <h2>System Configuration</h2>
    <mdb-btn size="sm" @click="add" icon="plus-circle">New Item</mdb-btn>
    <mdb-tbl striped responsive>
      <mdb-tbl-head>
        <tr>
          <th>Key</th>
          <th>Value</th>
          <th>Secret</th>
          <th style="width:10%;">&nbsp;</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
      <tr v-for="c in configuration" :key="c.id">
        <td>{{ c.configKey }}</td>
        <td v-if="!c.isSecret">{{ c.configVal }}</td>
        <td v-if="c.isSecret">*********************</td>
        <td><mdb-input type="checkbox" v-model="c.isSecret" disabled/></td>
        <td>
          <mdb-btn @click="editItem(c)" icon="pencil" size="sm" tag="a"  floating rounded/>
          <mdb-btn @click="deleteItem(c)" icon="trash" color="danger" size="sm" tag="a"  floating rounded/>

        </td>
      </tr>
      </mdb-tbl-body>
    </mdb-tbl>
    <yes-no-modal @yes="doDelete" @no="deleteModal=false" v-if="deleteModal"/>

    <mdb-modal v-if="editModal" @close="editModal = false">
      <mdb-modal-header :close="true" class="primary-color text-white">
        Edit {{working.configKey}}
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input v-model="working.configVal" label="Value"/>
        <mdb-input id="isSecret" v-model="working.isSecret" label="Secret?" type="checkbox"/>
        <mdb-btn :disabled="!working.configKey || !working.configVal" @click="save" icon="save" size="sm">Save</mdb-btn>
        <mdb-btn @click="editModal=false" icon="minus-circle" size="sm" color="warning">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="addModal" @close="addModal = false">
      <mdb-modal-header :close="true" class="primary-color text-white">
        New Item
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input v-model="working.configKey" label="Key"/>
        <mdb-input v-model="working.configVal" label="Value"/>
        <mdb-input id="isSecretAdd" v-model="working.isSecret" label="Secret?" type="checkbox"/>
        <mdb-btn :disabled="!working.configKey || !working.configVal" @click="save" icon="save" size="sm">Save</mdb-btn>
        <mdb-btn @click="addModal=false" icon="minus-circle" size="sm" color="warning">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
  </mdb-container>
</template>
<script>
import {
  mdbBtn,
  mdbContainer,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import YesNoModal from "../common/YesNoModal";

export default {
  name: "system-config",
  display: "System Configuration",
  order: 1,
  components: {
    mdbContainer,
    mdbInput,
    mdbBtn,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    YesNoModal
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  mounted() {
    this.loadConfig()
  },
  data() {
    return {
      configuration: [],
      deleteCandidate: null,
      deleteModal: false,
      editing: null,
      working: null,
      editModal: false,
      addModal: false,
    }
  },
  methods: {
    add() {
      this.working = { configKey: "", configVal: "", isSecret: false}
      this.addModal = true
    },
    editItem(i) {
      this.editing = i
      this.working = JSON.parse(JSON.stringify(i))
      this.editModal = true
    },
    save() {
      this.$store.dispatch("setExecuting", true)
      this.editModal = false
      this.addModal = false
      api.post("/admin/settings?key=" + this.working.configKey + "&val=" + this.working.configVal + "&isSecret=" + this.working.isSecret).then(
        (results) => {
          if (this.working.id) {
            this.editing.configVal = this.working.configVal
            this.editing.isSecret = this.working.isSecret
          }
          else {
            this.configuration.unshift( JSON.parse(JSON.stringify(this.working)))
            this.working = null
          }
          this.working = null
          this.editing = null
        },
        (error) => {
          this.$notify.error({message: error.response.data})
          if (this.working.id) this.editModal = true
          else this.addModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    deleteItem(i) {
      this.deleteCandidate = i
      this.deleteModal = true
    },
    doDelete() {
      this.$store.dispatch("setExecuting", true)
      this.deleteModal = false
      api.delete("/admin/settings/" + this.deleteCandidate.id).then(
        (results) => {
          let loc = this.configuration.indexOf(this.deleteCandidate)
          this.configuration.splice(loc,1)
          this.deleteCandidate = null
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    loadConfig() {
      this.$store.dispatch("setExecuting", true)
      api.get("/admin/settings").then(
        (results) => {
          this.configuration = results.data.allSettings
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

}
;
</script>
